// extracted by mini-css-extract-plugin
export default {"video-section":"r_bY d-flex","video-section--header":"r_bZ","video-section__frame":"r_b0 ml-3"};